import {
    ActionButton,
    Modal,
} from "components/commons";
import { StyleType } from "enums";
import React from "react";
import lang from "translations";
const MewsTroubleshootingModal = ({ ...props }) => {

    return (
        <Modal
            title={lang.mewsTroubleshootingSteps}
            {...props}
            actionContent={
                <ActionButton
                    className="px-md pb-md"
                    secondary={null}
                    primary={
                        {
                            type: StyleType.Secondary,
                            text: lang.okay,
                            onClick: () => {
                                props.close();
                            },
                        }
                    }
                />
            }
        >
            <p className="text-sm mb-xs font-bold">{lang.mewsTroubleshootingStep1Title}</p>
            <p className="text-sm mb-sm">
                {lang.mewsTroubleshootingStep1Desc}
            </p>
            <p className="text-sm mb-xs font-bold mt-md">{lang.mewsTroubleshootingStep2Title}</p>
            <p className="text-sm mb-sm">
                {lang.mewsTroubleshootingStep2DescStart}{" "}
                <a href="https://help.mews.com/s/article/set-up-your-editable-history-windows?language=en_US#link2a" target="_blank" rel="noreferrer" className="text-pelorous text-sm">{lang.thisArticle}</a>{" "}
                {lang.mewsTroubleshootingStep2DescEnd}
            </p>
            <p className="text-sm mb-xs font-bold mt-md">{lang.mewsTroubleshootingStep3Title}</p>
            <p className="text-sm mb-sm">
                {lang.mewsTroubleshootingStep3DescStart}{" "}
                <span className="text-gray text-sm">{lang.mewsTroubleshootingStep3Hint1}</span>{" "}
                {lang.mewsTroubleshootingStep3DescMiddle}{" "}
                <span className="text-gray text-sm">{lang.mewsTroubleshootingStep3Hint2}</span>.
            </p>
            <p className="text-sm mb-xs font-bold mt-md">{lang.mewsTroubleshootingStep4Title}</p>
            <p className="text-sm mb-sm">
                {lang.mewsTroubleshootingStep4Desc}{" "}
                <a href="https://help.socashless.com/support/solutions/articles/67000696705-end-of-day-reports" target="_blank" rel="noreferrer" className="text-sm text-pelorous">{lang.youCanFindMoreInformationAboutThisHere}</a>
            </p>

        </Modal>
    );
};

export default MewsTroubleshootingModal;
